import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { AggregatesModule } from "@tylertech/aggregates-module";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartingModule } from "@tylertech/charting-module";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CommonDialogsModule } from "@tylertech/common-dialogs-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { GeneralLedgerModule } from "@tylertech/general-ledger-module";
import { ProjectBudgetActivityChartComponent } from "./charts/projectBudgetActivityChart.component";
import { ProjectBudgetRecapChartComponent } from "./charts/projectBudgetRecapChart.component";
import { ProjectSummaryChartComponent } from "./charts/projectSummaryChart.component";
import { ProjectAccountingProjectsNearingBudgetLimitComponent } from "./charts/projectsNearingBudgetLimit.component";
import { ProjectAccountHeaderCardComponent } from "./components/header.card.component";
import { ProjectAccountDetailCardComponent } from "./components/projectAccountDetailCard.component";
import { ProjectAccountSearchDetailComponent } from "./components/projectAccountSearchDetail.component";
import { ProjectAccountCategoryLookupService } from "./services/projectAccountCategoryLookupService.g";
import { ProjectAccountLookupService } from "./services/projectAccountLookupService.g";
import { ProjectCategoryLookupService } from "./services/projectCategoryLookupService.g";
import { ProjectGroupLookupService } from "./services/projectGroupLookupService.g";
import { ProjectPriorityLookupService } from "./services/projectPriorityLookupService.g";
import { ProjectService } from "./services/projectService.g";
import { ProjectStatusLookupService } from "./services/projectStatusLookupService.g";
import { ProjectTypeLookupService } from "./services/projectTypeLookupService.g";

const angularModules = [
    CommonModule,
    FlexLayoutModule
];

const angularMaterialModules = [];

const lgdModules = [
    CommandsModule,
    CommonComponentsModule,
    CoreModule,
    CommonDialogsModule,
    CustomViewModule
        .withComponents(
            /* eslint-disable @typescript-eslint/naming-convention */
            {
                "project-accounting-project-budget-activity-chart": ProjectBudgetActivityChartComponent,
                "project-accounting-project-budget-recap-chart": ProjectBudgetRecapChartComponent,
                "project-accounting-projects-nearing-budget-limit": ProjectAccountingProjectsNearingBudgetLimitComponent,
                "project-summary-chart": ProjectSummaryChartComponent,
                /*
                 * TODO - used as a custom component in
                 * > apps\projectaccounting\src\components\accounts\search\search.tmpl.html
                 * > library\info-card\src\components\infoCardSearchDialog\infoCardSearchDialog.component.ts.
                 */
                "project-account-header-card": ProjectAccountHeaderCardComponent,
                /*
                 * TODO - used as a custom component in
                 * > apps\projectaccounting\src\components\accounts\search\search.tmpl.html
                 * > library\info-card\src\components\infoCardSearchDialog\infoCardSearchDialog.component.ts.
                 */
                "project-account-detail-card": ProjectAccountDetailCardComponent,
                /*
                 * TODO - used as a custom component in
                 * > apps\projectaccounting\src\components\search\projectAccountingSearch.tmpl.html.
                 */
                "project-account-search-detail-card": ProjectAccountSearchDetailComponent,
            }
            /* eslint-enable @typescript-eslint/naming-convention */
        ),
    AggregatesModule,
    GeneralLedgerModule,
    ChartJsContainerComponent,
    ChartingModule,
];

const components = [
    ProjectAccountSearchDetailComponent,
    ProjectAccountDetailCardComponent,
    ProjectAccountHeaderCardComponent,
    ProjectBudgetActivityChartComponent,
    ProjectBudgetRecapChartComponent,
    ProjectSummaryChartComponent,
    ProjectAccountingProjectsNearingBudgetLimitComponent,
];

@NgModule({
    imports: [...angularModules, ...angularMaterialModules, ...lgdModules],
    declarations: components,
    exports: components,
    providers: [
        ProjectTypeLookupService,
        ProjectStatusLookupService,
        ProjectPriorityLookupService,
        ProjectGroupLookupService,
        ProjectCategoryLookupService,
        ProjectAccountCategoryLookupService,
        ProjectService,
        ProjectAccountLookupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectAccountingModule { }
